/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, centerAbsolutely, color } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// IMAGE 1 ANSWER STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	uniqueanswer: {
		width: '100%',
		height: '100%',
		'& .group': {
			extend: centerAbsolutely
		}
	},
	graphic: {
		// backgroundImage - dynamic, comes from component which comes from settings
		backgroundColor: color.greyDark,
		backgroundPosition: '50% 50%',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		borderRadius: '50%',
		display: 'inline-block',
		width: pxToEm(80),
		height: pxToEm(80),
		position: 'relative',
		overflow: 'hidden',
		'& img': {
			borderRadius: 'inherit',
			width: '100%',
			height: 'auto'
		},
		'& :hover': {
			borderRadius: 'inherit'
		},
		'& .fade': {
			borderColor: color.greyDark, // animated by result state
			borderRadius: '50%',
			borderWidth: pxToEm(1),
			borderStyle: 'solid',
			display: 'block',
			opacity: '0', // animated by result state
			width: '100%',
			height: '100%',
			extend: centerAbsolutely
		}
	},
	desc: {
		background: 'rgba(255,255,255,0.30)',
		borderRadius: pxToEm(25),
		display: 'table', // animated by result state
		textAlign: 'center',
		margin: `${pxToEm(7)} auto 0 auto`,
		width: '90%',
		height: pxToEm(30),
		'& .text': {
			display: 'table-cell',
			fontFamily: 'Helvetica',
			fontSize: pxToEm(12),
			verticalAlign: 'middle',
			height: '100%',
			lineHeight: '1.1'
		}
	}
};